import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class SunsetPrintTshirtWhiteI extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.SunsetPrintTshirtWhiteI.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.SunsetPrintTshirtWhiteI.itemName}
                />
                <InfoItem
                    price={AW21.tops.SunsetPrintTshirtWhiteI.itemPrice}
                    fabric={AW21.tops.SunsetPrintTshirtWhiteI.itemFabric}
                />
                <SizeChart src={AW21.tops.SunsetPrintTshirtWhiteI.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtWhiteI.picture01}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtWhiteI.picture02}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtWhiteI.picture03}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtWhiteI.picture04}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtWhiteI.picture05}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.SunsetPrintTshirtWhiteI.picture06}
                                alt={AW21.alt}
                                width={AW21.imgWidth}
                                height={AW21.imgHeight}
                                loading="lazy"
                            />
                        </div>



                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.SunsetPrintTshirtWhiteI.shopifyDivId}
                    mainId={AW21.tops.SunsetPrintTshirtWhiteI.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default SunsetPrintTshirtWhiteI;
